import React, { useContext, useEffect } from 'react'
import { GrownupsContext } from "../../../GrownupsContext";

import "./SelectColorScheme.css"

const schemes = {
    // === CLASSIC ===
    basic: {
        name: "Classic",
        colors: ["#ffffff", "#f5f5f5","#EEEEEE","#DDDDDD", "#AAAAAA", "#666666"],
        fonts: { primary: "'IBM Plex Mono', monospace", heading: "'Playfair Display', serif", googleFont: 'IBM+Plex+Mono:wght@400;500;600|Playfair+Display:wght@700' },
        effects: {}
    },
    executive: {
        name: "Executive",
        colors: ["#ffffff", "#f8f8f8", "#e8e8e8", "#cccccc", "#666666", "#1a1a1a"],
        fonts: { primary: "'Inter', sans-serif", heading: "'Oswald', sans-serif", googleFont: 'Inter:wght@400;500;600;700|Oswald:wght@500;600;700' },
        effects: { sharp: true }
    },
    newspaper: {
        name: "Newspaper",
        colors: ["#fffef9", "#f5f4ef", "#e8e7e2", "#d0cfc8", "#666666", "#1a1a1a"],
        fonts: { primary: "'Libre Franklin', sans-serif", heading: "'Playfair Display', serif", googleFont: 'Libre+Franklin:wght@400;500;600|Playfair+Display:wght@700;800' },
        effects: { sharp: true }
    },
    grownups: {
        name: "Grownups",
        colors: ["#cbe6db","#86B4A3","#abdbc9","#ffffff","#5c9681","#537f75"],
        fonts: { primary: "'Nunito', sans-serif", heading: "'Pacifico', cursive", googleFont: 'Nunito:wght@400;500;600|Pacifico' },
        effects: { rounded: true }
    },

    // === NATURE ===
    forest: {
        name: "Forest",
        colors: ["#F7FFF8","#DBE9E0","#BFD3C8","#A3BCB0","#87A698","#6B9080"],
        fonts: { primary: "'Nunito', sans-serif", heading: "'Cormorant Garamond', serif", googleFont: 'Nunito:wght@400;500;600|Cormorant+Garamond:wght@600;700' },
        effects: { rounded: true }
    },
    grass: {
        name: "Grass",
        colors: ["#E5FFEF","#C1F1CC","#9DE3A9","#7AD685","#56C862","#02750D"],
        fonts: { primary: "'Nunito', sans-serif", heading: "'Cormorant Garamond', serif", googleFont: 'Nunito:wght@400;500;600|Cormorant+Garamond:wght@600;700' },
        effects: { rounded: true }
    },
    matcha: {
        name: "Matcha",
        colors: ["#f4f9f4","#e8f3e8","#d4e8d4","#a8c5a8","#5a7d6f","#2d4a3e"],
        fonts: { primary: "'Nunito', sans-serif", heading: "'Cormorant Garamond', serif", googleFont: 'Nunito:wght@400;500;600|Cormorant+Garamond:wght@600;700' },
        effects: { rounded: true, softShadow: '0 2px 10px rgba(45,74,62,0.08)' }
    },
    cottagecore: {
        name: "Cottagecore",
        colors: ["#f5f0e8","#ebe4d4","#e8e0d0","#9caa97","#7a7265","#5c5346"],
        fonts: { primary: "'Crimson Text', serif", heading: "'Great Vibes', cursive", googleFont: 'Crimson+Text:wght@400;600;700|Great+Vibes' },
        effects: { rounded: true, soft: true }
    },
    goblincore: {
        name: "Goblincore",
        colors: ["#121510","#1a201a","#232b22","#4a6848","#7d9c78","#d4e6d0"],
        fonts: { primary: "'Kalam', cursive", heading: "'Rye', serif", googleFont: 'Kalam:wght@400;700|Rye' },
        effects: { earthy: true, textShadow: '1px 1px 4px rgba(0,0,0,0.7)' }
    },

    // === OCEAN & SKY ===
    sea: {
        name: "Ocean",
        colors: ["#E7F8FF","#B9DEED","#8BC3DB","#5CA9CA","#2E8EB8","#0074A6"],
        fonts: { primary: "'DM Sans', sans-serif", heading: "'Playfair Display', serif", googleFont: 'DM+Sans:wght@400;500;700|Playfair+Display:wght@700' },
        effects: { rounded: true }
    },
    sky: {
        name: "Sky",
        colors: ["#F3F7FF","#CDD9FC","#A7BCF8","#809EF5","#5A81F1","#3463EE"],
        fonts: { primary: "'DM Sans', sans-serif", heading: "'Playfair Display', serif", googleFont: 'DM+Sans:wght@400;500;700|Playfair+Display:wght@700' },
        effects: { rounded: true }
    },

    // === WARM TONES ===
    pink: {
        name: "Pink",
        colors: ["#FFF6FA", "#FFE5F0", "#FFC6DF", "#FF80B8", "#F1569A", "#9E0045"],
        fonts: { primary: "'Quicksand', sans-serif", heading: "'Pacifico', cursive", googleFont: 'Quicksand:wght@400;500;600|Pacifico' },
        effects: { rounded: true }
    },
    roseGold: {
        name: "Rose Gold",
        colors: ["#fdf8f6","#faf0ed","#f5e6e2","#e8c4bc","#8c7a7a","#5c4a4a"],
        fonts: { primary: "'Quicksand', sans-serif", heading: "'Playfair Display', serif", googleFont: 'Quicksand:wght@400;500;600|Playfair+Display:wght@600;700' },
        effects: { rounded: true, softShadow: '0 2px 12px rgba(92,74,74,0.06)' }
    },
    blood: {
        name: "Blood",
        colors: ["#FDEAEA","#F4BDC8","#EB90A5","#E36383","#DA3660","#D1093E"],
        fonts: { primary: "'Libre Franklin', sans-serif", heading: "'Rozha One', serif", googleFont: 'Libre+Franklin:wght@400;500;700|Rozha+One' },
        effects: {}
    },
    orange: {
        name: "Orange",
        colors: ["#FFFBF6","#FFE1C5","#FFC694","#FFAC62","#FF9131","#FF7700"],
        fonts: { primary: "'DM Sans', sans-serif", heading: "'Playfair Display', serif", googleFont: 'DM+Sans:wght@400;500;700|Playfair+Display:wght@700' },
        effects: { rounded: true }
    },
    gold: {
        name: "Gold",
        colors: ["#FFF9ED","#FFEFBE","#FFE58E","#FFDC5F","#FFD22F","#DCAC00"],
        fonts: { primary: "'DM Sans', sans-serif", heading: "'Playfair Display', serif", googleFont: 'DM+Sans:wght@400;500;700|Playfair+Display:wght@700' },
        effects: { rounded: true }
    },

    // === NEUTRAL & EARTH ===
    brown: {
        name: "Brown",
        colors: ["#F1E7DB","#D8C9B6","#C0AC92","#A78E6D","#8F7149","#765324"],
        fonts: { primary: "'EB Garamond', serif", heading: "'Cinzel', serif", googleFont: 'EB+Garamond:wght@400;600|Cinzel:wght@600;700' },
        effects: {}
    },
    marronbeige: {
        name: "Marron Beige",
        colors: ["#F8EDE3","#F1E7DB", "#DFD3C3","#D0B8A8","#c6ab98","#85586F"],
        fonts: { primary: "'DM Sans', sans-serif", heading: "'Cormorant Garamond', serif", googleFont: 'DM+Sans:wght@400;500;700|Cormorant+Garamond:wght@600;700' },
        effects: { rounded: true }
    },
    millennialBeige: {
        name: "Millennial Beige",
        colors: ["#f5f0eb","#ebe4dc","#e8dfd4","#c4b8a8","#7a7a7a","#3d3d3d"],
        fonts: { primary: "'DM Sans', sans-serif", heading: "'Cormorant Garamond', serif", googleFont: 'DM+Sans:wght@400;500;700|Cormorant+Garamond:wght@600;700' },
        effects: { rounded: true, softShadow: '0 2px 8px rgba(0,0,0,0.08)' }
    },

    // === PURPLE ===
    purple: {
        name: "Purple",
        colors: ["#F4E8FC","#D9BAFD","#BF8BFD","#A45DFE","#8A2EFE","#6F00FF"],
        fonts: { primary: "'Quicksand', sans-serif", heading: "'Pacifico', cursive", googleFont: 'Quicksand:wght@400;500;600|Pacifico' },
        effects: { rounded: true }
    },

    // === DARK THEMES (Enhanced for stunning visuals) ===
    strangerThings: {
        name: "Stranger Things",
        colors: ["#0a0408","#120810","#1a0c14","#c41e3a","#d4a574","#fff0e6"],
        fonts: { primary: "'Inconsolata', monospace", heading: "'Creepster', cursive", googleFont: 'Inconsolata:wght@400;500;700|Creepster' },
        effects: { glow: '0 0 15px #ff0040, 0 0 30px #c41e3a', titleGlow: '0 0 30px #ff0040', textShadow: '0 0 10px rgba(196, 30, 58, 0.8)' }
    },
    matrix: {
        name: "Matrix",
        colors: ["#000000","#020808","#041410","#00ff41","#00b830","#ccffcc"],
        fonts: { primary: "'Fira Code', monospace", heading: "'Share Tech Mono', monospace", googleFont: 'Fira+Code:wght@400;500;600|Share+Tech+Mono' },
        effects: { codeRain: true, textShadow: '0 0 8px #00ff41, 0 0 20px #00ff41', scanlines: true, glow: '0 0 20px rgba(0, 255, 65, 0.4)' }
    },
    darkAcademia: {
        name: "Dark Academia",
        colors: ["#15120e","#1f1a14","#2a2319","#8b7355","#c4a77d","#e8dcc8"],
        fonts: { primary: "'Crimson Text', serif", heading: "'Cinzel Decorative', serif", googleFont: 'Crimson+Text:wght@400;600;700|Cinzel+Decorative:wght@400;700' },
        effects: { texture: true, vintage: true, textShadow: '1px 1px 3px rgba(0,0,0,0.6)' }
    },
    tumblr2014: {
        name: "Tumblr 2014",
        colors: ["#0f0f0f","#1a1a1a","#242424","#3d3d3d","#b0b0b0","#f5f5f5"],
        fonts: { primary: "'Source Sans 3', sans-serif", heading: "'Playfair Display', serif", googleFont: 'Source+Sans+3:wght@400;600;700|Playfair+Display:wght@700;800' },
        effects: { desaturated: true, textShadow: '0 1px 2px rgba(0,0,0,0.8)' }
    },
    ai2025: {
        name: "2025 AI",
        colors: ["#08080c","#0f0f14","#18182a","#7c3aed","#a78bfa","#f0f0ff"],
        fonts: { primary: "'Space Grotesk', sans-serif", heading: "'Orbitron', sans-serif", googleFont: 'Space+Grotesk:wght@400;500;600;700|Orbitron:wght@500;700;900' },
        effects: { gradient: 'linear-gradient(135deg, #7c3aed 0%, #ec4899 50%, #06b6d4 100%)', glow: '0 0 30px rgba(124, 58, 237, 0.5)', textShadow: '0 0 15px rgba(167, 139, 250, 0.6)' }
    },

    // === RETRO & NOSTALGIA (Enhanced) ===
    blog2006: {
        name: "2006 Blog",
        colors: ["#050005","#0d0510","#150818","#ff1493","#ff69b4","#fff0f8"],
        fonts: { primary: "'Courier Prime', monospace", heading: "'Permanent Marker', cursive", googleFont: 'Courier+Prime:wght@400;700|Permanent+Marker' },
        effects: { sparkles: true, hearts: true, border: '2px dashed #ff1493', textShadow: '2px 2px 0 #ff00ff, -1px -1px 0 #00ffff', glow: '0 0 20px rgba(255, 20, 147, 0.5)' }
    },
    ascii80s: {
        name: "80s ASCII",
        colors: ["#000000","#040808","#081510","#33ff33","#00cc00","#b0ffb0"],
        fonts: { primary: "'VT323', monospace", heading: "'Press Start 2P', cursive", googleFont: 'VT323|Press+Start+2P' },
        effects: { scanlines: true, crtGlow: '0 0 8px #33ff33', textShadow: '0 0 15px #33ff33, 0 0 30px #00cc00', glow: '0 0 25px rgba(51, 255, 51, 0.4)' }
    },
    vaporwave: {
        name: "Vaporwave",
        colors: ["#0d001a","#1a0033","#2a0052","#ff71ce","#01cdfe","#b967ff"],
        fonts: { primary: "'Lexend', sans-serif", heading: "'Monoton', cursive", googleFont: 'Lexend:wght@400;500;600|Monoton' },
        effects: { gradient: 'linear-gradient(135deg, #1a0033 0%, #4d0099 50%, #1a0033 100%)', textShadow: '0 0 15px currentColor, 0 0 30px rgba(185, 103, 255, 0.5)', glow: '0 0 30px rgba(1, 205, 254, 0.4)' }
    },
    windows95: {
        name: "Windows 95",
        colors: ["#008080","#c0c0c0","#006666","#000000","#404040","#000000"],
        fonts: { primary: "'Pixelify Sans', sans-serif", heading: "'Pixelify Sans', sans-serif", googleFont: 'Pixelify+Sans:wght@400;700' },
        effects: { boxShadow: 'inset -1px -1px #0a0a0a, inset 1px 1px #ffffff, inset -2px -2px #808080, inset 2px 2px #dfdfdf', retro: true }
    },
    windowsXP: {
        name: "Windows XP",
        colors: ["#3A6EA5","#ECE9D8","#6699CC","#0054E3","#333333","#000000"],
        fonts: { primary: "'Outfit', sans-serif", heading: "'Outfit', sans-serif", googleFont: 'Outfit:wght@400;500;600;700' },
        effects: { gradient: 'linear-gradient(180deg, #0054E3 0%, #2683FF 100%)', rounded: true }
    },
    msPaint: {
        name: "MS Paint",
        colors: ["#ffffff","#c0c0c0","#c0c0c0","#000000","#808080","#000000"],
        fonts: { primary: "'Comic Neue', cursive", heading: "'Comic Neue', cursive", googleFont: 'Comic+Neue:wght@400;700' },
        effects: { pixelated: true, border: '2px solid #000000' }
    },

    // === POP CULTURE ===
    brat: {
        name: "BRAT",
        colors: ["#8ACE00","#9BD61A","#7BB800","#000000","#333333","#000000"],
        fonts: { primary: "'Inter', sans-serif", heading: "'Archivo Black', sans-serif", googleFont: 'Inter:wght@400;500;700|Archivo+Black' },
        effects: { bold: true }
    },
    barbiecore: {
        name: "Barbiecore",
        colors: ["#FFB6C1","#FFC0CB","#FFD1DC","#FF1493","#A0306B","#8B0051"],
        fonts: { primary: "'Nunito', sans-serif", heading: "'Pacifico', cursive", googleFont: 'Nunito:wght@400;600;700|Pacifico' },
        effects: { rounded: true, glow: '0 0 20px rgba(255, 105, 180, 0.5)' }
    },
    lisaFrank: {
        name: "Lisa Frank",
        colors: ["#9932CC","#BA55D3","#8B008B","#FFD700","#FFE4F0","#FFFFFF"],
        fonts: { primary: "'Baloo 2', cursive", heading: "'Bungee Shade', cursive", googleFont: 'Baloo+2:wght@400;500;700|Bungee+Shade' },
        effects: { rainbow: true, sparkles: true, headerBg: 'linear-gradient(90deg, #FF0000, #FF7F00, #FFFF00, #00FF00, #0000FF, #8B00FF)' }
    },
    wesAnderson: {
        name: "Wes Anderson",
        colors: ["#f8e5d2","#fdf6ed","#fadcd9","#d4a574","#5d6d7e","#2c3e50"],
        fonts: { primary: "'Jost', sans-serif", heading: "'Abril Fatface', serif", googleFont: 'Jost:wght@400;500;600|Abril+Fatface' },
        effects: { symmetrical: true, pastel: true }
    },

    // === FANTASY (Enhanced with magical effects) ===
    lotr: {
        name: "Middle Earth",
        colors: ["#0e0c08","#1a1610","#28221a","#8b7355","#c4a574","#f0e6d2"],
        fonts: { primary: "'Cormorant Garamond', serif", heading: "'Uncial Antiqua', serif", googleFont: 'Cormorant+Garamond:wght@400;500;600;700|Uncial+Antiqua' },
        effects: { elvish: true, parchment: true, textShadow: '2px 2px 4px rgba(0,0,0,0.7)', glow: '0 0 20px rgba(196, 165, 116, 0.3)' }
    },
    gryffindor: {
        name: "Gryffindor",
        colors: ["#2a0000","#4a0000","#6e0000","#ffd700","#f5c518","#fff8e0"],
        fonts: { primary: "'Crimson Pro', serif", heading: "'Cinzel Decorative', serif", googleFont: 'Crimson+Pro:wght@400;500;600;700|Cinzel+Decorative:wght@700;900' },
        effects: { glow: '0 0 25px rgba(255, 215, 0, 0.5)', textShadow: '2px 2px 4px rgba(0,0,0,0.7), 0 0 15px rgba(255, 215, 0, 0.3)' }
    },
    slytherin: {
        name: "Slytherin",
        colors: ["#040a06","#0a1a10","#122a1a","#c0c0c0","#e8e8e8","#f5f5f5"],
        fonts: { primary: "'Spectral', serif", heading: "'Cinzel Decorative', serif", googleFont: 'Spectral:wght@400;500;600|Cinzel+Decorative:wght@700;900' },
        effects: { glow: '0 0 25px rgba(192, 192, 192, 0.5)', textShadow: '2px 2px 4px rgba(0,0,0,0.8), 0 0 12px rgba(192, 192, 192, 0.4)' }
    },
    hufflepuff: {
        name: "Hufflepuff",
        colors: ["#FFD800","#ffe135","#e6c200","#000000","#333333","#000000"],
        fonts: { primary: "'Vollkorn', serif", heading: "'Cinzel Decorative', cursive", googleFont: 'Vollkorn:wght@400;500;600|Cinzel+Decorative:wght@700' },
        effects: { glow: '0 0 15px rgba(0, 0, 0, 0.3)', textShadow: '1px 1px 2px rgba(255,216,0,0.5)' }
    },
    ravenclaw: {
        name: "Ravenclaw",
        colors: ["#040810","#0a1020","#101830","#cd7f32","#e6a855","#fff5e6"],
        fonts: { primary: "'Cormorant', serif", heading: "'Cinzel Decorative', serif", googleFont: 'Cormorant:wght@400;500;600;700|Cinzel+Decorative:wght@700;900' },
        effects: { glow: '0 0 25px rgba(205, 127, 50, 0.5)', textShadow: '2px 2px 4px rgba(0,0,0,0.8), 0 0 12px rgba(205, 127, 50, 0.4)' }
    },

    // === MINIMAL & MODERN ===
    apple: {
        name: "Apple",
        colors: ["#ffffff","#f5f5f7","#fbfbfd","#d2d2d7","#86868b","#1d1d1f"],
        fonts: { primary: "'Inter', sans-serif", heading: "'Inter', sans-serif", googleFont: 'Inter:wght@400;500;600;700' },
        effects: { clean: true, rounded: true, shadow: '0 2px 10px rgba(0,0,0,0.08)' }
    },
    calmPastel: {
        name: "Calm Pastel",
        colors: ["#fdf8f5","#f5eeea","#f0e8e3","#e0d5cf","#8a8a8a","#5a5a5a"],
        fonts: { primary: "'Quicksand', sans-serif", heading: "'Poppins', sans-serif", googleFont: 'Quicksand:wght@400;500;600|Poppins:wght@500;600;700' },
        effects: { soft: true, rounded: true }
    },
    americana: {
        name: "Americana",
        colors: ["#faf8f5","#f5f0e6","#e8d4b8","#1a2744","#5c6b7a","#1a2744"],
        fonts: { primary: "'Libre Baskerville', serif", heading: "'Playfair Display', serif", googleFont: 'Libre+Baskerville:wght@400;700|Playfair+Display:wght@700' },
        effects: { texture: true }
    },
};

// Helper to detect if a color is dark (for text contrast)
const isColorDark = (hexColor) => {
    if (!hexColor) return false;
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    // Calculate relative luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance < 0.5;
};

// Load Google Font for theme
const loadGoogleFont = (googleFont) => {
    if (!googleFont) return;

    const existingLink = document.getElementById('theme-google-font');
    if (existingLink) existingLink.remove();

    const fontFamilies = googleFont.split('|').map(f => `family=${f}`).join('&');

    const link = document.createElement('link');
    link.id = 'theme-google-font';
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?${fontFamilies}&display=swap`;
    document.head.appendChild(link);

    // Force font application after load
    link.onload = () => {
        document.body.style.fontFamily = 'inherit';
        setTimeout(() => {
            document.body.style.fontFamily = '';
        }, 10);
    };
};

// Apply theme effects
const applyThemeEffects = (effects) => {
    const root = document.documentElement;

    // Reset effects
    root.style.setProperty('--theme-glow', 'none');
    root.style.setProperty('--theme-text-shadow', 'none');
    root.style.setProperty('--theme-box-shadow', 'none');
    root.style.setProperty('--theme-border-radius', '4px');
    root.style.setProperty('--theme-border-width', '1px');
    root.style.setProperty('--theme-cell-border', 'none');
    root.classList.remove('theme-scanlines', 'theme-sparkles', 'theme-rainbow', 'theme-sharp');

    if (!effects) return;

    if (effects.glow) root.style.setProperty('--theme-glow', effects.glow);
    if (effects.textShadow) root.style.setProperty('--theme-text-shadow', effects.textShadow);
    if (effects.boxShadow) root.style.setProperty('--theme-box-shadow', effects.boxShadow);
    if (effects.rounded) root.style.setProperty('--theme-border-radius', '12px');
    if (effects.sharp) {
        root.style.setProperty('--theme-border-radius', '0px');
        root.style.setProperty('--theme-border-width', '2px');
        root.style.setProperty('--theme-cell-border', '1px solid var(--color-scheme-inactive-button)');
        root.classList.add('theme-sharp');
    }
    if (effects.scanlines) root.classList.add('theme-scanlines');
    if (effects.sparkles) root.classList.add('theme-sparkles');
    if (effects.rainbow) root.classList.add('theme-rainbow');
};

export const applyAppColors = (colors, setBackgroundColor, setBackgroundColorCalendar, setFonts = null) => {
    const theme = schemes[colors] || schemes.basic;
    const scheme = theme.colors;

    setBackgroundColor(scheme[1])
    setBackgroundColorCalendar(scheme[0])

    // Update the 3 major fonts based on theme
    if (setFonts && theme.fonts) {
        setFonts({
            'Title': theme.fonts.heading,
            'My Task List': theme.fonts.heading,
            'My Task': theme.fonts.primary
        });
    }

    const root = document.documentElement;

    // Detect if this is a dark theme (background is dark)
    const isDarkTheme = isColorDark(scheme[0]) || isColorDark(scheme[1]);

    // For dark themes: use light colors (5) for text; for light themes: use dark colors (4, 5)
    // scheme[5] should always be the highest contrast text color
    const primaryText = scheme[5];  // Main readable text
    const secondaryText = scheme[4]; // Slightly muted text
    const accentColor = scheme[3];  // Accent/highlight color

    // Sidebar text must always be readable on sidebar background (scheme[1])
    const sidebarText = isDarkTheme ? scheme[5] : scheme[5];
    const sidebarSecondaryText = isDarkTheme ? scheme[4] : scheme[4];

    // Colors
    root.style.setProperty('--color-scheme-calendar-background', scheme[0]);
    root.style.setProperty('--color-scheme-background', scheme[1]);
    root.style.setProperty('--color-scheme-text', isDarkTheme ? scheme[4] : scheme[2]);
    root.style.setProperty('--color-scheme-titles', primaryText);
    root.style.setProperty('--color-scheme-inactive-button', secondaryText);
    root.style.setProperty('--color-scheme-time-selection', scheme[1]);
    root.style.setProperty('--color-scheme-time-selection-color', sidebarText);
    root.style.setProperty('--color-scheme-tab-text-color', sidebarText);
    root.style.setProperty('--color-scheme-tab-color', scheme[2]);
    root.style.setProperty('--color-scheme-tab-hover', `${accentColor}80`);
    root.style.setProperty('--color-scheme-tab-text-color-active', isDarkTheme ? scheme[5] : accentColor);
    root.style.setProperty('--color-scheme-tab-color-active', secondaryText);
    root.style.setProperty('--color-scheme-current-day-circle', accentColor);
    root.style.setProperty('--color-scheme-current-day-circle-text', isDarkTheme ? scheme[0] : scheme[0]);
    root.style.setProperty('--color-scheme-general-text', primaryText);
    root.style.setProperty('--color-scheme-fonts', primaryText);
    root.style.setProperty('--color-scheme-fonts-background', scheme[1]);
    root.style.setProperty('--color-scheme-current-time-color', secondaryText);
    root.style.setProperty('--color-scheme-event-text', primaryText);

    // NEW: Dedicated sidebar colors for guaranteed readability
    root.style.setProperty('--color-scheme-sidebar-text', sidebarText);
    root.style.setProperty('--color-scheme-sidebar-secondary', sidebarSecondaryText);
    root.style.setProperty('--color-scheme-sidebar-accent', accentColor);
    root.style.setProperty('--color-scheme-sidebar-border', isDarkTheme ? `${scheme[4]}40` : `${scheme[3]}30`);

    // Add a class for dark themes to help with CSS targeting
    if (isDarkTheme) {
        root.classList.add('dark-theme');
    } else {
        root.classList.remove('dark-theme');
    }

    // Fonts - load Google Fonts first
    if (theme.fonts) {
        loadGoogleFont(theme.fonts.googleFont);
        root.style.setProperty('--theme-font-primary', theme.fonts.primary);
        root.style.setProperty('--theme-font-heading', theme.fonts.heading);
    }

    // Effects
    applyThemeEffects(theme.effects);
};

export const SelectColorScheme = () => {
    const {colors, setColors} = useContext(GrownupsContext);

    // Apply theme on mount and when colors change
    useEffect(() => {
        const theme = schemes[colors];
        if (theme) {
            // Load fonts
            if (theme.fonts?.googleFont) {
                loadGoogleFont(theme.fonts.googleFont);
                const root = document.documentElement;
                root.style.setProperty('--theme-font-primary', theme.fonts.primary);
                root.style.setProperty('--theme-font-heading', theme.fonts.heading);
            }
            // Apply effects
            applyThemeEffects(theme.effects);
        }
    }, [colors]);

    return (<div style={{display: 'flex', flexDirection: 'column', gap:'4px', width: '100%'}}>
    {
        Object.keys(schemes).map(name =>
        (
        <div className={name === colors ? 'selectedscheme' : 'scheme'}
                key={name}
                onClick={()=>setColors(name)}
                style={{padding: '3px', borderRadius: '10px', cursor: 'pointer'}}>

            <div style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                height: '28px',
                overflow: 'hidden',
                borderRadius: '10px',
                position: 'relative',
            }}>
                {schemes[name].colors.map((color, idx) =>
                    <div
                        key={`${name}${color}${idx}`}
                        style={{backgroundColor: color, width: '100%'}}
                    />
                )}
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '8px',
                    transform: 'translateY(-50%)',
                    fontSize: '11px',
                    fontWeight: '600',
                    color: schemes[name].colors[5],
                    textShadow: `0 0 3px ${schemes[name].colors[0]}, 0 0 6px ${schemes[name].colors[0]}`,
                    pointerEvents: 'none',
                }}>
                    {schemes[name].name}
                </div>
            </div>
        </div>))
}</div>)
};
